// extracted by mini-css-extract-plugin
export default {"phoneLabel":"phoneInput_phoneLabel__eKIxg","phoneInput":"phoneInput_phoneInput__aVOgk","PhoneNumber":"phoneInput_PhoneNumber__rEHMb"};